import { appConfig } from '../../../../config'
import {
  HealthPlanCardResponse,
  CarePlanFormatted,
  HealthPlanSummary,
  HealthPlanOutcomeResponse,
  CheckListResponse,
} from './types'

const healthProgramUrl = (path: string) => `${appConfig.serverRootUrl}/api/private/healthProgram/${path}`

export const getHealthPlanSummary = async ({ accessToken }: { accessToken: string }): Promise<HealthPlanSummary> => {
  const res = await fetch(healthProgramUrl('summary'), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || 'Failed to fetch health plan summary')
  }
  return data
}

export const getUserHealthPlanOutcomes = async ({
  accessToken,
}: {
  accessToken: string
}): Promise<HealthPlanOutcomeResponse> => {
  const res = await fetch(healthProgramUrl('healthPlanOutcomes'), {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  const data = await res.json()

  if (!res.ok) {
    throw new Error(data?.message || 'Failed to fetch health plan outcomes')
  }

  return data
}

export const getHealthPlanCards = async ({
  accessToken,
}: {
  accessToken: string
}): Promise<HealthPlanCardResponse[]> => {
  const res = await fetch(healthProgramUrl('healthCards'), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const data: HealthPlanCardResponse[] = await res.json()

  if (!res.ok) {
    throw new Error('Failed to fetch health plan cards')
  }

  return data
}

export const getCarePlan = async ({ accessToken }: { accessToken: string }): Promise<CarePlanFormatted> => {
  const res = await fetch(healthProgramUrl('carePlan'), {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const data: CarePlanFormatted = await res.json()

  if (!res.ok) {
    throw new Error('Failed to fetch care plan')
  }

  return data
}

export const getCheckList = async ({ accessToken }: { accessToken: string }): Promise<CheckListResponse> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthPlanV2/checkList`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const data: CheckListResponse = await res.json()

  if (!res.ok) {
    throw new Error('Failed to fetch checklist')
  }

  return data
}

export const patchCheckListItem = async ({ accessToken, priority }: { accessToken: string; priority: number }) => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthPlanV2/checkList`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ priority }),
  })
  const data = await res.json()
  if (!res.ok) {
    throw new Error(data?.message || 'Unknown error')
  }

  return data
}
